export const SET_MOEDAS = "MOEDAS/SET_MOEDAS";
export const SET_MOEDA = "MOEDAS/SET_MOEDA";
export const SET_PAGINATION = "MOEDAS/SET_PAGINATION";
